<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="purple">
            <h4 class="title">Create New Client</h4>
          </md-card-header>
          <md-card-content>
            <div>
              <md-field :class="messageClass">
                <label>Name</label>
                <md-input v-model="name" required></md-input>
                <span class="md-error">This field is required</span>
              </md-field>
              <md-field>
                <label for="client type">Client Type</label>
                <md-select
                  v-model="client_type"
                  name="client_type"
                  id="client_type"
                >
                  <md-option value="public">Public</md-option>
                  <md-option value="confidential">Confidential</md-option>
                </md-select>
              </md-field>
              <md-field>
                <label for="response type">Response Type</label>
                <md-select
                  v-model="response_type"
                  name="response_type"
                  id="response_type"
                  multiple
                >
                  <md-option value="Code">Code</md-option>
                  <md-option value="id-token"
                    >id-token(Implicit Flow)</md-option
                  >
                  <md-option value="id-token token"
                    >id-token token (Implicit Flow)</md-option
                  >
                  <md-option value="code token"
                    >code token (Hybrid Flow)</md-option
                  >
                  <md-option value="code id-token"
                    >code id-token (Hybrid Flow)</md-option
                  >
                  <md-option value="code id-token token"
                    >code id-token token(Hybrid Flow)</md-option
                  >
                </md-select>
              </md-field>
            </div>
            <md-divider></md-divider>
            <div>
              <md-field>
                <label>Redirect URIs</label>
                <md-textarea v-model="redirectURIs"></md-textarea>
              </md-field>
              <md-field>
                <label for="client type">JWT Algorithm</label>
                <md-select
                  v-model="jwt_algorithm"
                  name="jwt_algorithm"
                  id="jwt_algorithm"
                >
                  <md-option value="HS256">HS256</md-option>
                  <md-option value="RS256">RS256</md-option>
                </md-select>
              </md-field>
            </div>
            <md-checkbox v-model="requireConsent">Require Consent?</md-checkbox>
            <md-checkbox v-model="reuseConsent">Reuse Consent?</md-checkbox>
            <md-field :class="messageClass">
              <label>Scopes</label>
              <md-textarea v-model="scopes"></md-textarea>
              <span class="md-helper-text"
                >Specifies the authorized scope values for the client app.</span
              >
            </md-field>
            <md-divider></md-divider>
            <h5 class="title">Post Logout Redirect URIs:</h5>
            <md-field :class="messageClass">
              <md-textarea v-model="postLogOutRedirectURIs"></md-textarea>
              <span class="md-helper-text">Enter each URI on a new line.</span>
            </md-field>
            <md-button class="md-primary" @click="createNewClient"
              >Submit</md-button
            >
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sso-management",
  props: [],
  data: function() {
    return {
      name: null,
      hasMessages: true,
      client_type: "public",
      response_type: "",
      redirectURIs: "",
      jwt_algorithm: "RS256",
      requireConsent: true,
      reuseConsent: true,
      scopes: "",
      postLogOutRedirectURIs: ""
    };
  },
  methods: {
    createNewClient: function() {}
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": this.hasMessages
      };
    }
  }
};
</script>
